module.exports = __webpack_public_path__ + "static/media/icons8-react-100.8fce55f4.png";